import { documentationActions } from '../../actions/constant';
const {
  SUCCESS_REASSIGN_THERAPIST,
  FAILURE_REASSIGN_THERAPIST,
  LOADING_REASSIGN_THERAPIST,
  RESET_REASSIGN_THERAPIST,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isReAssign: false,
  loading: false,
};

export const reAssigntherapistReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_REASSIGN_THERAPIST: {
      return {
        ...state,
        isReAssign: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_REASSIGN_THERAPIST:
      return {
        ...state,
        isReAssign: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_REASSIGN_THERAPIST:
      return {
        ...state,
        loading: true,
      };

    case RESET_REASSIGN_THERAPIST:
      return intitialstate;

    default:
      return state;
  }
};
